module.exports = __webpack_public_path__ + "static/media/legendary_booster.356f3537.webp";